import { ResolveFn } from '@angular/router';
import { SchoolLevelResponse } from '../../features/admin/schools/models/school-level.models';
import { inject } from '@angular/core';
import { StudentEnrollmentService } from '../../features/student/services/student-enrollment.service';
import { AuthenticationService } from '../../features/auth/services/authentication.service';
import { AcademicYearResponse } from '../../features/admin/schools/models/school-academic-year.models';
import { LonniyireLocalstorageService, StorageKey } from '../services/lonniyire-localstorage-service';
import { tap } from 'rxjs';

export const schoolLevelReferenceResolver: ResolveFn<SchoolLevelResponse[]> = () => {
  const lonniyireLocalStorage = inject(LonniyireLocalstorageService);
  const schoolLevels = lonniyireLocalStorage.getItem(StorageKey.SCHOOL_LEVELS) as SchoolLevelResponse[] | undefined;

  if (schoolLevels) {
    return Promise.resolve(schoolLevels);
  }

  const authenticationService = inject(AuthenticationService);
  const enrollmentService = inject(StudentEnrollmentService);
  const activeSchoolId = authenticationService.activeSchoolId();
  return enrollmentService.getSchoolLevels(activeSchoolId!).pipe(
    tap((levels) => {
      lonniyireLocalStorage.setItem(StorageKey.SCHOOL_LEVELS, levels);
    }),
  );
};

export const academicYearResolver: ResolveFn<AcademicYearResponse[]> = () => {
  const lonniyireLocalStorage = inject(LonniyireLocalstorageService);
  const academicYears = lonniyireLocalStorage.getItem(StorageKey.ACADEMIC_YEARS) as AcademicYearResponse[] | undefined;

  if (academicYears) {
    return Promise.resolve(academicYears);
  }

  const authenticationService = inject(AuthenticationService);
  const enrollmentService = inject(StudentEnrollmentService);

  const activeSchoolId = authenticationService.activeSchoolId();
  return enrollmentService.loadAcademicYears(activeSchoolId!).pipe(
    tap((years) => {
      lonniyireLocalStorage.setItem(StorageKey.ACADEMIC_YEARS, years);
    }),
  );
};
